import { Box, Flex, HStack, Heading, Text, VStack, useMediaQuery, chakra, Spacer, ButtonGroup, Button, Image } from '@chakra-ui/react';
import { AccountContext } from 'components/AccountContext';
import ChildHeader from 'components/Dashboard/Main/ChildHeader';
import React, { useContext } from 'react';
import EmojiCoracoes from '../../../images/EmojiCoracoes.svg';
function TitularFaleceu() {
  const { setPage, setUser, user } = useContext(AccountContext);
  setPage('Cancelamento do contrato');
  const [isMinHeight] = useMediaQuery('(max-height: 667px)');
  const [iphoneXr] = useMediaQuery('(max-height: 896px)');
  return (
    <>
      <ChildHeader />
      <VStack w={'100%'} overflowY="auto" maxHeight="calc(100vh - 200px)">
        <Box w={'74%'}>
          <HStack justify="space-between" w="100%" mt={'1em'}>
            <Heading fontSize="18px" color={'#5AB2AE'} fontWeight={'bold'}>
              Lamentamos o ocorrido... Desejamos todo conforto aos amigos e familiares
            </Heading>
          </HStack>
          <VStack align="left" mb={'1em'} mt={'1em'}>
            <chakra.span fontSize="16px" color={'#585858'}>
              Pedimos que entre em contato conosco através do Call Center. Será necessário o envio da certidão de óbito do titular.
            </chakra.span>
          </VStack>
          <ButtonGroup
            pt="1rem"
            pb="25%"
            sx={{ width: '75%', position: 'fixed', bottom: 0 }}
            onClick={() => {
              window?.open('https://wa.me/5508002802133', '_blank');
            }}
          >
            <Button name="btn" color="white" bg={'#5AB2AE'} type="submit" w={{ base: '100%' }} h={'2em'}>
              Seguir para o Call Center
            </Button>
          </ButtonGroup>
        </Box>
      </VStack>
    </>
  );
}

export default TitularFaleceu;
